// @flow
import React from 'react'
import PropTypes from 'prop-types'
import StateTag from './state-tag'
import values from 'lodash/values'
import { BID_STATE } from '../../services/bid/constants'
import { getBidTagData } from './utils'

const BidStateTag = ({ bidState }: { bidState: string }) => (
  <StateTag {...getBidTagData(bidState)} />
)

BidStateTag.propTypes = {
  bidState: PropTypes.oneOf(values(BID_STATE))
}

export default BidStateTag



// WEBPACK FOOTER //
// ./src/ui/tags/bid-state-tag.js